export * from './image-variant.pipe';
export * from './image-variant.module';
